import { DropdownQuestionModel } from './../../shared/models/dropdown-question.model';
import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';
import { QuestionBaseModel } from '../../shared/models/question-base.model';
import { SelectListItemModel } from '../../shared/models/select-list-item.model';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { SecurityService } from 'app/security/security.service';
import { EnrollmentProgramsService } from 'app/shared/services/enrollment-programs.service';
import { BaseFormValidation } from 'app/shared/validators/base-form-validation';
import { Observable } from 'rxjs/Observable';
import { PrintService } from 'app/shared/services/print.service';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'online-app-summary-stage',
  templateUrl: './summary-stage.component.html',
  styleUrls: ['./summary-stage.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummaryStageComponent extends BaseFormValidation implements OnInit {

  public imageUrl: Observable<string>;
  
  private isValidStatusesForSubmit: boolean = false;
  //private validStatusesForSubmit : Array<string> = ['Login Created','In Progress','In progress','Online Application Submitted'];  
  private validStatusesForSubmit: Array<string> = ['Login Created', 'In Progress', 'In progress']; //PYN -1512
  protected stagesControls: any[] = [];
  // private _stages : SelectListItemModel[];

  public opportunityStatement: string;
  @Input() protected set isSelected(val) {
    if (val)
      this.cd.markForCheck();
  }

  @Input() protected stagesForm: FormGroup;

  protected form: FormGroup;


  @Input() protected questions: QuestionBaseModel<any>[];

  @Input() protected stages: SelectListItemModel[];

  @Output() onAgreed: EventEmitter<void> = new EventEmitter();

  constructor(protected securityService: SecurityService, private cd: ChangeDetectorRef,
    private programsService: EnrollmentProgramsService,
    private fb: FormBuilder, private printService: PrintService,
    private http: HttpClient,
    private router: Router ) {
    super();
    this.getOpportunityStatement();
    this.createForm();
  }

  ngOnInit() {
    this.isValidStatusesForSubmit = this.validStatusesForSubmit.indexOf(this.securityService.currentUserInfo.status) > -1;
    this.initAcknowledgement();
    //console.log('current user ->', this.securityService.currentUserInfo);
    if(this.securityService.currentUserInfo.documentRequested && (sessionStorage.getItem('isProviderAccess') == null 
      || sessionStorage.getItem('isProviderAccess') == 'false')){
        this.router.navigate(['/additional-resources']);
    }
  }

  private getFieldValue(question, value) {
    switch (question.fieldTypeName) {
      case SummerAppFieldTypesEnum.Input:
      case SummerAppFieldTypesEnum.Numeric:
      case SummerAppFieldTypesEnum.SchoolsAutoComplete:
        return value;

      case SummerAppFieldTypesEnum.Label:
        return "";

      case SummerAppFieldTypesEnum.SSN:
        return value.substr(7, 4);

      case SummerAppFieldTypesEnum.Date:
        if (!Date.parse(value))
          return '';
        let date = <Date>value;
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

      case SummerAppFieldTypesEnum.Dropdown:
        let opt = (<DropdownQuestionModel>question).options.find(i => i.value == value);
        return opt ? opt.name : '';

      case SummerAppFieldTypesEnum.Checkbox:
        return value ? (<string>value).toString().toLowerCase() == 'true' ? 'Yes' : 'No' : 'No';

      case SummerAppFieldTypesEnum.YesNoSelector:
        return value ? (<string>value).toString().toLowerCase() == '1' ? 'Yes' : 'No' : '';

      case SummerAppFieldTypesEnum.ResumeUpload:
        return value || question.file ? 'File Uploaded' : 'No File';
    }
  }

  initAcknowledgement() {
    let status = this.securityService.currentUserInfo.acknowledgementStatus;
    if (status != null) {
      this.form.get('isAgree').setValue(status);
    }
  }

  getStageFields(form: FormGroup) {
    let keys = Object.keys(form.controls).filter(i => i !== 'notSubmitted');
    return keys.map((key) => {
      let question = this.questions.find(t => t.fieldName == key);
      let value = this.getFieldValue(question, form.get(key).value);

      // hide covid vaccination status field value if user is not author of current application
      if (key == "COVID_VACCINATION_STATUS"){
        var login = this.securityService.currentUserInfo.email;
        if (!/.+@.+\..+/.test(login)){
          value = "****";
        }
      }

      // if (key == 'Label'){
      //   return {
      //     label: question.label,
      //     value:""
      //    }    
      //  }    
      return {
        label: question.label,
        value: value
      }
    });
  }

  private getOpportunityStatement() {
    let programAlias = this.securityService.currentUserInfo.enrollmentProgramAlias;
    this.programsService.getProgramStatements(programAlias).subscribe(data => {
      this.imageUrl = this.programsService.getBackgroundImageUrl(programAlias);
      this.opportunityStatement = data.eqOpportunityErStatement;
    });
  }

  private createForm() {
    this.form = this.fb.group({
      isAgree: [false, Validators.pattern('true')]
    });
  }

  protected Agreed() {
    this.onAgreed.emit();

  }

  public get OpportunityStatement(): Observable<string> {
    return this.programsService.getOpportunityStatement();
  }

  public get canSubmit(): boolean {
    if (!this.form.invalid && this.isValidStatusesForSubmit) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/stages/summary-stage/summary-stage.component.ts